import { supabase } from "@/lib/supabase/client";
import type { CustomDocumentFormData } from "@/pages/dashboard/document-generator";

export interface CustomDocumentDraft extends CustomDocumentFormData {
  id: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export const saveDraft = async (
  userId: string,
  draftData: CustomDocumentFormData
): Promise<CustomDocumentDraft> => {
  const { data, error } = await supabase
    .from("custom_document_drafts")
    .insert([
      {
        user_id: userId,
        ...draftData,
      },
    ])
    .select()
    .single();

  if (error) {
    console.error("Error saving draft:", error);
    throw new Error(error.message);
  }

  return data;
};
